import React, { useState } from 'react';
import axios from 'axios';
import { describeLocation, ShopLocation } from '../utils/weather';
import { pageCache } from '../utils/pageCache';

/** The shop's street address — where ClearPath looks up the weather. Saved on its own. */
export default function ShopAddressField({ initial }: { initial?: ShopLocation | null }) {
  const [address, setAddress] = useState(initial?.address ?? '');
  const [loc, setLoc] = useState<ShopLocation | null>(initial ?? null);
  const [saving, setSaving] = useState(false);
  const [failed, setFailed] = useState(false);

  const save = async () => {
    setSaving(true);
    setFailed(false);
    try {
      const res = await axios.put('/api/settings/location', { address });
      setLoc(res.data.location);
      pageCache.clear('/api/weather');
    } catch {
      setFailed(true);
    } finally {
      setSaving(false);
    }
  };

  const status = failed ? 'That address was not saved. Try again.' : describeLocation(loc);
  return (
    <div>
      <label htmlFor="shop-address" className="block text-sm font-sans font-medium text-[#2D2A2E] mb-1.5">Street address</label>
      <div className="flex gap-2">
        <input
          id="shop-address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="123 Main St, Dayton, OH"
          className="w-full bg-white border border-[#E6E2DE] focus:ring-2 focus:ring-[#4A2D5E]/20 focus:border-[#4A2D5E] rounded-[8px] h-11 font-sans text-sm px-3 outline-none transition-all"
        />
        <button
          onClick={save}
          disabled={saving}
          className="shrink-0 bg-white border border-[#E6E2DE] hover:border-[#4A2D5E] text-[#2D2A2E] rounded-[8px] h-11 px-4 font-sans text-sm font-medium transition-colors disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4A2D5E] focus-visible:ring-offset-2"
        >
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
      {status && <p className="font-sans text-xs text-[#6B6670] mt-1.5">{status}</p>}
    </div>
  );
}
